// Préférence de densité GLOBALE du design system V2.
//
// Pourquoi ici : ~80 vues instancient leur propre <ThemeAProvider> ; une prop
// posée sur le provider du shell ne les atteint jamais. La densité est donc un
// petit store module-level auquel chaque ThemeAProvider s'abonne (via
// useSyncExternalStore) quand aucune densité explicite ne lui est passée.
const STORAGE_KEY = "akV2Density";

export const DENSITY_OPTIONS = Object.freeze(["comfortable", "compact"]);
export const DEFAULT_DENSITY = "comfortable";

const listeners = new Set();

const readStorage = () => {
  try {
    const value = typeof window !== "undefined" ? window.localStorage?.getItem?.(STORAGE_KEY) : null;
    return DENSITY_OPTIONS.includes(value) ? value : DEFAULT_DENSITY;
  } catch (_) {
    return DEFAULT_DENSITY;
  }
};

let current = readStorage();

export const getDensityPreference = () => current;

export const subscribeDensityPreference = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setDensityPreference = (density) => {
  const resolved = DENSITY_OPTIONS.includes(density) ? density : DEFAULT_DENSITY;
  if (resolved === current) return current;
  current = resolved;
  try {
    if (resolved === DEFAULT_DENSITY) window.localStorage?.removeItem?.(STORAGE_KEY);
    else window.localStorage?.setItem?.(STORAGE_KEY, resolved);
  } catch (_) {
    // Stockage indisponible : la densité vaut pour la session courante.
  }
  listeners.forEach((listener) => listener(current));
  return current;
};
